import React, { ChangeEvent, MouseEvent } from 'react';
import cx from 'classnames';

import { CloseIcon } from 'components/close/close-icon';
import Input from 'components/input/input';
import Loading from 'components/loading/loading';

import styles from './input-field.module.css';

type InputFieldProps = {
    value: string;
    onClick?: (event: MouseEvent<HTMLInputElement>) => void;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
    onCancel: () => void;
    processing: boolean;
    placeholder?: string;
    /** in the search panel of a page: the close button stays next to the input on mobile */
    isSearchPanel?: boolean;
};

/** The search input of the page search panels */
export const InputField = ({
    value,
    onClick,
    onChange,
    onCancel,
    processing,
    placeholder = 'Search',
    isSearchPanel = false
}: InputFieldProps) => (
    <div className={styles.wrapper}>
        <Input
            className={styles.input}
            autoFocus
            placeholder={placeholder}
            value={value}
            onClick={onClick}
            onChange={onChange}
        />
        <button
            type="button"
            className={cx(styles.closeButton, { [styles.closeButtonInPanel]: isSearchPanel })}
            onClick={onCancel}
        >
            {processing ? <Loading spinner /> : null} <CloseIcon />
        </button>
    </div>
);
